// extracted by mini-css-extract-plugin
export default {"upload":"Upload_upload__nzgYN","OpacityTransition":"Upload_OpacityTransition__heSws","heading":"Upload_heading__ywSmb"};